import React from 'react';
import moment, { Moment } from 'moment';
import EnrichmentStatusTable from '../components/EnrichmentStatusTable';
import { connectToActiveSocket, popupErrorFromServer } from '../util/helperFunctions';
import AnimalSignoutCard from '../components/AnimalInfoCard';
import styled from 'styled-components';
import Animal from '../Entities/Animal';
import api from '../util/api';
import { Container } from 'bloomer/lib/layout/Container';
import { Box } from 'bloomer/lib/elements/Box';
import { Icon } from 'bloomer/lib/elements/Icon';
import soriAnimalsByBioSecurityLocationAndMedicalTag from '../util/sort';
import { PatioRuleProvider } from '../DataProviders/PatioRules';
import { trackers } from '../util/analytics';

interface PropTypes {
  path: string;
  animalType?: animalType;
}
interface StateTypes {
  animals: Animal[];
  enrichmentTypes: [string, string][];
  loading: boolean;
  comments: Comment[];
  commentModalOpen: boolean;
  loadingComments: boolean;
  commentAnimal: Animal | undefined;
  enrichmentData: Enrichment[];
  commentStartDate: Moment | undefined;
  daysOfCommentsLoaded: number;
  loadingMoreComments: boolean;
  socket: SocketIOClient.Socket | undefined;
}

const BackToTop = styled(Box)<any>`
  position: fixed;
  bottom: 10px;
  left: 10px;
  background: white;
  z-index: 1;
  &:hover {
    color: blue;
    border-color: blue;
    background: lightgrey;
  }
`;

const CenteredIcon = styled.div<any>`
  margin: 0 auto;
  display: block;
  text-align: center;
`;

class Enrichmentlist extends React.Component<PropTypes, StateTypes> {
  state: StateTypes = {
    animals: [],
    enrichmentTypes: [],
    loading: true,
    comments: [],
    commentModalOpen: false,
    loadingComments: true,
    commentAnimal: undefined,
    enrichmentData: [],
    commentStartDate: undefined, // Meaning the earliest date
    daysOfCommentsLoaded: 14,
    loadingMoreComments: false,
    socket: undefined,
  };

  refreshEnrichmentData = async (callback?: () => {}) => {
    try {
      const enrichmentData = await api.enrichmentData.get({
        startDate: moment()
          .startOf('day')
          .toISOString(),
        endDate: moment()
          .endOf('day')
          .toISOString(),
      });
      this.setState(
        {
          enrichmentData,
        },
        callback,
      );
      return enrichmentData;
    } catch (err) {
      popupErrorFromServer(err);
    }
  };

  componentDidMount() {
    const { animalType } = this.props;
    if (!animalType) {
      return;
    }
    this.refreshEnrichmentData();

    const socket = connectToActiveSocket(animalType, async (animals: Ianimal[]) => {
      this.setState({
        socket,
        animals: soriAnimalsByBioSecurityLocationAndMedicalTag(
          animals
            .map(animal => new Animal(animal))
            .map(animal => {
              return animal;
            }),
        ),
        loading: false,
      });
    });
  }

  scrollToCard = (animal: Animal) => {
    const card = document.getElementById(`info-card-${animal.aNumber}`);
    if (card) {
      window.scrollTo(0, card.offsetTop);
    }
  };

  render() {
    const { loading, animals, enrichmentData } = this.state;
    return (
      <Container>
        <PatioRuleProvider>
          <EnrichmentStatusTable
            loading={loading}
            animals={animals}
            enrichmentData={enrichmentData}
            handleRowClick={this.scrollToCard}
          />
          {animals.map((animal: Animal) => (
            <AnimalSignoutCard key={animal.aNumber} animal={animal} refresh={this.refreshEnrichmentData} />
          ))}
          <a href="#root" onClick={() => trackers.dogList.click().BACK_TO_TOP()}>
            <BackToTop>
              <CenteredIcon>
                <Icon className="fa fa-angle-up" />
              </CenteredIcon>
              <p>Back to Top</p>
            </BackToTop>
          </a>
        </PatioRuleProvider>
      </Container>
    );
  }

  componentWillUnmount() {
    const { socket } = this.state;
    if (socket) {
      socket.disconnect();
    }
  }
}

export default Enrichmentlist;
